/**
 * @generated SignedSource<<391bb1494df7c1afc5c0c388e47482b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CDPAudienceSelector_brand$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useBrandAudiences_brand">;
  readonly " $fragmentType": "CDPAudienceSelector_brand";
};
export type CDPAudienceSelector_brand$key = {
  readonly " $data"?: CDPAudienceSelector_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"CDPAudienceSelector_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CDPAudienceSelector_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBrandAudiences_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "40150914f813b01abc6194ef8906e2ff";

export default node;
